import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { LotCodeOpsEntity } from './entities/lot-code.entity';
import { ProdInvAdapter } from './dto/prod-inv.adapter';
import { ProductionLogRepository } from './repositories/production-log.repository';
import { ProductionLogService } from './production-log.service';

import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { HLpercentagesService, SuppliersService, UnitcodeService } from '@gtpl/shared-services/masters';
import { IndentService } from '@gtpl/shared-services/raw-material-procurement';
import { LotCodeOpsService } from './lot-code-ops.service';
import { LotCodeOpsController } from './lot-code-ops.controller';
import { LotCodeOpsAdapter } from './dto/lot-code.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LotCodeOpsRepository } from './repositories/lot-code.repository';
import { RawMaterialRepository } from './repositories/raw-materail.repository';
import { ProductionInventoryRepository } from './repositories/production-inventory.repository';
import { RawMaterialService } from './raw-material.service';
import { RawMaterialController } from './raw-material.controller';
import { BeHeadingController } from './be-heading.controller';
import { BeHeadingService } from './be-heading.service';
import { SoakingService } from './soaking.service';
import { SoakingController } from './soaking.controller';
import { FreezingService } from './freezing.service';
import { FreezingController } from './freezing.controller';


import { ValAdditionOperationController } from './val-addition.controller';
import { ValAdditionOperationService } from './val-addition.service';
import { productionInventoryController } from './production-inventory.controller';
import { ProductionInventoryService } from './production-inventory.service';
import { VariantOperationsModule } from '../variant-operations/variant-operations.module';
import { ProductionLogAdapter } from './dto/production-log.adapter';
import { WorkstationsModule } from '../workstations/workstations.module';
import { GradeInventoryController } from './grade-inventory.controller';
import { GradeInventoryService } from './grade-inventory.service';
import { GradeInventoryRepository } from './repositories/grade-inventory.repository';
import { WorkstationService } from '@gtpl/shared-services/production';
import { GradeInventoryLogRepository } from './repositories/grade-inventory-log.repository';
import { ProductionLogController } from './production-log.controller';
import { StockTransferController } from './stock-transfer/stock-transfer.controller';
import { StockTransferService } from './stock-transfer/stock-transfer.service';
import { StockTransferLog } from './entities/stock-transfer-log';
import { DeheadingSampleController } from './deheading-sample/deheading-sample.controller';
import { DeheadingSampleService } from './deheading-sample/deheading-sample.service';
import { DeheadingSampleRepository } from './repositories/deheading-sample.repository';
import { DeheadingSampleAdapter } from './dto/deheading-sample.adpater';
import { DeheadingQAQCRepository } from './repositories/deheading-qaqc.repository';
import { BlanchingCookingAdapter } from './dto/blanching-cooking.adapter';
import { BlanchingCookingService } from './blanching-cooking/blanching-cooking.service';
import { BlanchingCookingController } from './blanching-cooking/blanching-cooking.controller';
import { BlanchingCooking } from './entities/blanching-cooking.entity';
import { SoakingSampleTestModule } from './soaking-sample-test/soaking-sample-test.module';
import { GradingMonitoringController } from './grading-monitoring/grading-monitoring.controller';
import { GradingMonitoringService } from './grading-monitoring/grading-monitoring.service';
import { GradeMonitoringAdapter } from './dto/grade-monitoring.adapter';
import { GradingMonitoring } from './entities/grading-monitoring.entity';
import { GradeMonitoringRepository } from './repositories/grade-monitoring.repository';
import { PeelingService } from './peeling/peeling.service';
import { PeelingController } from './peeling/peeling.controller';
import { PeelingSamplesRepository } from './peeling/repositories/peeling-samples.repository';
import { PeelingRepository } from './peeling/repositories/peeling.repository';
import { PeelingAdapter } from './peeling/dto/peeling.adapter';
import { CookingController } from './cooking/cooking.controller';
import { CookingService } from './cooking/cooking.service';
import { FgInspectionRepository } from './fg-inspection/repositories/fg-inspection.repository';
import { FgInspectionSamples } from './fg-inspection/entities/fg-inspection-samples.entity';
import { FgInspection } from './fg-inspection/entities/fg-inspection.entity';
import { FgInspectionAdapter } from './fg-inspection/dto/fg-inspection.adapter';
import { FgInspectionService } from './fg-inspection/fg-inspection.service';
import { FgInspectionController } from './fg-inspection/fg-inspection.controller';
import { FgInspectionSamplesRepository } from './fg-inspection/repositories/fg-inspection-samples.repository';


@Module({

    imports: [
        TypeOrmModule.forFeature([RawMaterialRepository, LotCodeOpsEntity, ProductionLogRepository, LotCodeOpsRepository, ProductionInventoryRepository,GradeInventoryRepository,GradeInventoryLogRepository,StockTransferLog, DeheadingQAQCRepository, DeheadingSampleRepository,GradeMonitoringRepository,BlanchingCooking,GradingMonitoring,PeelingRepository,PeelingSamplesRepository,FgInspectionRepository,FgInspectionSamplesRepository]),
        VariantOperationsModule,WorkstationsModule, SoakingSampleTestModule
      ],
      providers: [ SaleOrderService, SuppliersService, IndentService, ProdInvAdapter, LotCodeOpsService, LotCodeOpsAdapter, ApplicationExceptionHandler,  ProductionLogService, BeHeadingService, ValAdditionOperationService, SoakingService, FreezingService,ProductionInventoryService, ProductionLogAdapter, GradeInventoryService,WorkstationService,UnitcodeService,StockTransferService, DeheadingSampleService, DeheadingSampleAdapter,BlanchingCookingAdapter,BlanchingCookingService, GradingMonitoringService,GradeMonitoringAdapter, PeelingService,PeelingAdapter, CookingService,FgInspectionAdapter,FgInspectionService],
     
      controllers: [ LotCodeOpsController, BeHeadingController, ValAdditionOperationController, SoakingController, FreezingController,productionInventoryController, GradeInventoryController,ProductionLogController,StockTransferController, DeheadingSampleController,BlanchingCookingController, GradingMonitoringController, PeelingController, CookingController,FgInspectionController],
      exports:[ LotCodeOpsService]

})


export class OperationsTrackModule {}
